(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-ascent"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cp-home-motion')) {
  customElements.define('cp-home-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        this.stopMotion();
        if (!this.preference.matches && 'IntersectionObserver' in window && Element.prototype.animate) this.startMotion();
      };
      this.preference.addEventListener('change', update, { signal: this.lifecycle.signal });
      update();
    }

    disconnectedCallback() {
      this.stopMotion();
      this.lifecycle?.abort();
      this.lifecycle = null;
    }

    stopMotion() {
      this.motion?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.animations?.forEach(animation => animation.cancel());
      this.classList.remove('cp-motion-active');
      this.querySelectorAll('.cp-card-revealed').forEach(card => card.classList.remove('cp-card-revealed'));
      ['--cp-depth', '--cp-zoom', '--cp-print-scale', '--cp-print-turn', '--cp-map-turn', '--cp-map-scale', '--cp-ring-turn', '--cp-hero-inset', '--cp-hero-radius', '--cp-title-lift'].forEach(name => this.style.removeProperty(name));
      this.querySelectorAll('.cp-home-study svg path').forEach(path => path.style.removeProperty('--cp-line-offset'));
      this.querySelectorAll('.cp-home-product').forEach(card => ['--cp-card-clip', '--cp-card-zoom', '--cp-card-turn'].forEach(name => card.style.removeProperty(name)));
    }

    startMotion() {
      this.motion = new AbortController();
      this.animations = new Set();
      const signal = this.motion.signal;
      const hero = this.querySelector('.cp-home-hero');
      const study = this.querySelector('.cp-home-study');
      const cards = [...this.querySelectorAll('.cp-home-product')];
      const paths = [...study.querySelectorAll('svg path')];
      paths.forEach(path => path.setAttribute('pathLength', '1000'));
      const compact = () => innerWidth < 800;
      const clamp = value => Math.min(1, Math.max(0, value));
      const animate = (element, frames, options = {}) => {
        const animation = element.animate(frames, { duration: 950, easing: 'cubic-bezier(.18,.7,.2,1)', ...options });
        this.animations.add(animation);
        animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
      };
      this.classList.add('cp-motion-active');

      const render = () => {
        this.frame = 0;
        if (!this.isConnected || document.hidden) return;
        const viewport = innerHeight;
        const heroBox = hero.getBoundingClientRect();
        const mapBox = study.getBoundingClientRect();
        if (heroBox.bottom > 0 && heroBox.top < viewport) {
          const progress = clamp(-heroBox.top / (heroBox.height * .85));
          this.style.setProperty('--cp-depth', `${(progress * (compact() ? 85 : 140)).toFixed(2)}px`);
          this.style.setProperty('--cp-zoom', (1.03 + progress * .4).toFixed(3));
          this.style.setProperty('--cp-print-scale', (1 + progress * .12).toFixed(3));
          this.style.setProperty('--cp-print-turn', `${(progress * (compact() ? 8 : -10)).toFixed(3)}deg`);
          this.style.setProperty('--cp-title-lift', `${(-progress * 65).toFixed(2)}px`);
          this.style.setProperty('--cp-hero-inset', `${(progress * 3).toFixed(2)}%`);
          this.style.setProperty('--cp-hero-radius', `${(progress * 42).toFixed(2)}px`);
        }
        const progress = clamp((viewport * .88 - mapBox.top) / Math.min(viewport * .65, mapBox.height + 180));
        this.style.setProperty('--cp-map-turn', `${(-24 + progress * 24).toFixed(3)}deg`);
        this.style.setProperty('--cp-map-scale', (.7 + progress * .3).toFixed(3));
        this.style.setProperty('--cp-ring-turn', `${(-65 + progress * 90).toFixed(3)}deg`);
        paths.forEach((path, index) => {
          const line = clamp(progress * 1.3 - index * .018);
          path.style.setProperty('--cp-line-offset', ((1 - line) * 1000).toFixed(1));
        });
      };
      const request = () => { if (!this.frame) this.frame = requestAnimationFrame(render); };
      document.addEventListener('scroll', request, { capture: true, passive: true, signal });
      window.addEventListener('resize', request, { passive: true, signal });
      document.addEventListener('visibilitychange', request, { signal });
      this.addEventListener('focusin', event => {
        if (!event.target.matches(':focus-visible')) return;
        this.animations.forEach(animation => animation.finish());
      }, { signal });

      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const element = entry.target;
          this.observer.unobserve(element);
          if (element === study) {
            animate(study.querySelector('.cp-home-study-ring'), [
              { opacity: 0, scale: '.78' }, { opacity: 1, scale: '1' }
            ], { duration: 1500 });
            animate(study.querySelector('.cp-home-elevation'), [
              { opacity: 0, translate: '0 18px' }, { opacity: 1, translate: '0 0' }
            ], { duration: 950, delay: 250, fill: 'backwards' });
          } else if (cards.includes(element)) {
            const index = cards.indexOf(element);
            const delay = (index % (compact() ? 2 : 3)) * 90;
            element.style.setProperty('--cp-card-delay', `${delay + 250}ms`);
            element.classList.add('cp-card-revealed');
            animate(element.querySelector('.cp-home-product-info'), [
              { opacity: .65 }, { opacity: 1 }
            ], { duration: 850, delay, fill: 'backwards' });
          } else {
            animate(element, [
              { opacity: .72, translate: '0 32px' },
              { opacity: 1, translate: '0 0' }
            ], { duration: 800 });
          }
        }
      }, { threshold: .12, rootMargin: '0px 0px -20px 0px' });
      this.querySelectorAll('.cp-home-heading,.cp-home-product,.cp-home-regions,.cp-home-study,.cp-home-story-copy,.cp-set-copy,.cp-editorial-details,.cp-discover-card').forEach(element => this.observer.observe(element));
      request();
    }
  });
}

{
  const clamp = value => Math.min(1, Math.max(0, value));
  class CairnScrollSurface extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.tall = matchMedia('(min-height: 570px)');
      const update = () => {
        this.stop();
        if (this.dataset.enabled !== 'false' && !this.reduced.matches && this.tall.matches && 'IntersectionObserver' in window) this.start();
      };
      this.reduced.addEventListener('change', update, { signal: this.lifecycle.signal });
      this.tall.addEventListener('change', update, { signal: this.lifecycle.signal });
      update();
    }
    disconnectedCallback() {
      this.stop();
      this.lifecycle?.abort();
      this.lifecycle = null;
    }
    listen() {
      this.motion = new AbortController();
      this.classList.add('cp-scroll-enabled');
      this.request = () => {
        if (this.raf || !this.motion || this.motion.signal.aborted) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          if (this.isConnected && !document.hidden) this.render();
        });
      };
      const signal = this.motion.signal;
      document.addEventListener('scroll', this.request, { capture: true, passive: true, signal });
      window.addEventListener('resize', this.request, { passive: true, signal });
      document.addEventListener('visibilitychange', this.request, { signal });
      this.addEventListener('focusin', event => {
        const target = event.target;
        if (!target.matches(':focus-visible')) return;
        const rect = target.getBoundingClientRect();
        if (rect.top < 80 || rect.bottom > innerHeight - 20) target.scrollIntoView({ block: 'center', behavior: 'instant' });
      }, { signal });
      this.request();
    }
    stop() {
      this.motion?.abort();
      this.nearby?.disconnect();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.classList.remove('cp-scroll-enabled');
      this.cleanup?.();
    }
  }
  if (!customElements.get('cp-cinematic')) customElements.define('cp-cinematic', class extends CairnScrollSurface {
    start() {
      if (navigator.connection?.saveData) return;
      this.print = this.querySelector('print');
      this.context = this.print?.getContext('2d', { alpha: false });
      if (!this.context) return;
      this.urls = this.print.dataset.atlases.split('|');
      if (this.urls.length !== 6) return;
      this.stage = this.querySelector('.cp-cinema-stage');
      this.chapters = [...this.querySelectorAll('[data-chapter]')];
      this.cache = new Map();
      this.pending = new Map();
      this.failed = new Set();
      this.desired = 0;
      this.drawn = -1;
      this.ready = false;
      this.listen();
      this.nearby = new IntersectionObserver(entries => {
        this.ready = entries.some(entry => entry.isIntersecting);
        if (this.ready) this.request();
      }, { rootMargin: '100% 0px' });
      this.nearby.observe(this);
    }
    load(index) {
      if (index < 0 || index >= this.urls.length || this.cache.has(index) || this.pending.has(index) || this.failed.has(index)) return;
      const signal = this.motion.signal;
      const image = new Image();
      image.decoding = 'async';
      this.pending.set(index, image);
      image.onerror = () => {
        if (signal.aborted) return;
        this.pending.delete(index);
        this.failed.add(index);
      };
      image.onload = async () => {
        try {
          await image.decode();
          if (signal.aborted) return;
          if (image.naturalWidth !== 2400 || image.naturalHeight !== 1800) throw new Error('Unexpected sequence dimensions');
          this.pending.delete(index);
          this.cache.set(index, image);
          const current = Math.floor(this.desired / 12);
          [...this.cache.keys()].sort((a,b) => Math.abs(a-current)-Math.abs(b-current)).slice(3).forEach(key => this.cache.delete(key));
          this.request();
        } catch {
          if (!signal.aborted) { this.pending.delete(index); this.failed.add(index); }
        }
      };
      image.src = this.urls[index];
    }
    render() {
      const rect = this.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight * 2) return;
      const top = parseFloat(getComputedStyle(this.stage).top) || 0;
      const progress = clamp((top - rect.top) / Math.max(1, rect.height - this.stage.offsetHeight));
      const wall = clamp((progress - .68) / .16);
      this.style.setProperty('--cp-progress', progress.toFixed(4));
      this.style.setProperty('--cp-wall', wall.toFixed(4));
      this.style.setProperty('--cp-terrain', (1-wall).toFixed(4));
      this.style.setProperty('--cp-framed-scale', (1.17-wall*.17).toFixed(4));
      this.style.setProperty('--cp-framed-turn', `${(-4+wall*4).toFixed(3)}deg`);
      const chapter = progress < .38 ? 0 : progress < .72 ? 1 : 2;
      this.chapters.forEach((element,index) => element.toggleAttribute('data-active', index === chapter));
      this.desired = Math.round(clamp(progress/.7)*71);
      if (!this.ready) return;
      const group = Math.floor(this.desired / 12);
      this.load(group);
      this.load(group + 1);
      this.load(group - 1);
      let frame = this.desired;
      let sheet = this.cache.get(group);
      if (!sheet && this.cache.size) {
        const nearest = [...this.cache.keys()].sort((a,b) => Math.abs(a-group)-Math.abs(b-group))[0];
        sheet = this.cache.get(nearest);
        frame = Math.max(nearest*12, Math.min(nearest*12+11, this.desired));
      }
      if (!sheet || frame === this.drawn) return;
      const tile = frame % 12;
      this.context.drawImage(sheet, (tile%4)*600, Math.floor(tile/4)*600, 600,600, 0,0,600,600);
      this.drawn = frame;
      this.classList.add('cp-has-frame');
    }
    cleanup() {
      this.classList.remove('cp-has-frame');
      ['--cp-progress','--cp-wall','--cp-terrain','--cp-framed-scale','--cp-framed-turn'].forEach(name => this.style.removeProperty(name));
      this.querySelectorAll('[data-chapter]').forEach(element => element.removeAttribute('data-active'));
      this.pending?.forEach(image => { image.onload = null; image.onerror = null; image.removeAttribute('src'); });
      this.pending?.clear();
      this.cache?.clear();
      this.ready = false;
    }
  });
  if (!customElements.get('cp-region-panels')) customElements.define('cp-region-panels', class extends CairnScrollSurface {
    start() {
      this.panels = [...this.querySelectorAll('.cp-region-panel')];
      this.listen();
    }
    render() {
      this.panels.forEach(panel => {
        const rect = panel.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        const progress = clamp((innerHeight - rect.top) / Math.max(1,innerHeight));
        panel.style.setProperty('--cp-region-shift', `${(5-progress*8).toFixed(3)}%`);
        panel.style.setProperty('--cp-art-shift', `${(30-progress*45).toFixed(2)}px`);
      });
    }
    cleanup() {
      this.querySelectorAll('.cp-region-panel').forEach(panel => {
        panel.style.removeProperty('--cp-region-shift');
        panel.style.removeProperty('--cp-art-shift');
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-explore"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){
 if(root.dataset.ready)return;
 let products;try{products=JSON.parse(root.querySelector('[data-experience-products]').textContent);}catch{return;}
 if(!products.length)return;root.dataset.ready='true';
 const money=new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
 const $=s=>root.querySelector(s), all=s=>[...root.querySelectorAll(s)];
 let selected=products.find(p=>p.handle===root.dataset.default)||products[0];
 const art=(p,c)=>c==='Midnight'&&p.artMidnight?p.artMidnight:p.art;
 const text=(s,v)=>{$(s).textContent=v;};
 const show=mode=>{all('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==mode);all('[data-mode-button]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.modeButton===mode)));};
 const room=()=>{const v=selected.variants.find(v=>String(v.id)===$('[data-room-size]').value);if(!v)return;$('[data-room-stage]').dataset.size=v.title.split(' ')[0];$('[data-room-art]').src=art(selected,v.colour);$('[data-room-art]').alt=selected.title+' — '+v.title;text('[data-room-caption]',selected.title+' / '+v.title);text('[data-room-price]',money.format(v.price/100)+(v.available?'':' · '+root.dataset.comingSoon));$('[data-room-link]').href=selected.url+'?variant='+v.id;};
 function choose(handle){selected=products.find(p=>p.handle===handle)||selected;all('[data-hill-select]').forEach(s=>s.value=selected.handle);const available=selected.variants;const oldT=$('[data-room-size]').selectedOptions[0]?.textContent||'',old=oldT.split(' ')[0];const opts=available.map(v=>{const o=document.createElement('option');o.value=v.id;o.textContent=v.title;return o;});const keep=opts.find(o=>o.textContent===oldT)||opts.find(o=>o.textContent.startsWith(old+' '));if(keep)keep.selected=true;$('[data-room-size]').replaceChildren(...opts);$('[data-map-photo]').src=selected.photo||selected.image;$('[data-map-photo]').alt=selected.photo?selected.title+' landscape':selected.title+' print';$('[data-map-art]').src=art(selected);text('[data-hill-title]',selected.title);text('[data-hill-facts]',[selected.facts.region,selected.facts.country,selected.facts.height?selected.facts.height+' m':''].filter(Boolean).join(' / '));text('[data-hill-price]',money.format(Math.min(...available.map(v=>v.price))/100)+(available.some(v=>v.available)?'':' · '+root.dataset.comingSoon));$('[data-hill-link]').href=selected.url;all('[data-map-hill]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mapHill===selected.handle)));room();}
 const chooser=document.createElement('div');chooser.className='cp-pin-chooser';chooser.hidden=true;
 const closeChooser=()=>{chooser.hidden=true};
 const focusCard=()=>{if(innerWidth>900)return;const c=$('.cp-map-feature')||$('[data-hill-title]');if(!c)return;const r=c.getBoundingClientRect();if(r.top<80||r.top>innerHeight*.6)c.scrollIntoView({block:'start',behavior:'smooth'})};
 function pinClick(b,handle){const r=b.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2,lim=Math.max(12,r.width*.75);const near=all('[data-map-hill]').filter(x=>{const q=x.getBoundingClientRect();return Math.hypot(q.left+q.width/2-cx,q.top+q.height/2-cy)<lim});if(near.length<2){closeChooser();choose(handle);focusCard();return}
  const head=document.createElement('p');head.textContent='Hills here';chooser.replaceChildren(head,...near.map(x=>{const o=document.createElement('button');o.type='button';o.innerHTML='<b></b> ';o.querySelector('b').textContent=x.querySelector('span')?.textContent||'';o.append(x.title);o.addEventListener('click',ev=>{ev.stopPropagation();closeChooser();choose(x.dataset.mapHill);focusCard()});return o}));
  const host=(b.offsetParent||b.parentElement).getBoundingClientRect();chooser.style.left=Math.min(Math.max(cx-host.left,95),host.width-95)+'px';chooser.style.top=(cy-host.top)+'px';chooser.hidden=false;chooser.querySelector('button').focus({preventScroll:true});}
 document.addEventListener('click',e=>{if(!chooser.hidden&&!chooser.contains(e.target)&&!e.target.closest('[data-map-hill]'))closeChooser()});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!chooser.hidden)closeChooser()});
 const offsets={'catbells':[-52,-12],'helvellyn':[46,-15],'scafell-pike':[-35,31]};
 products.filter(p=>p.facts.lat!==null).forEach((p,i)=>{const b=document.createElement('button');b.type='button';b.className='cp-map-pin';b.dataset.mapHill=p.handle;b.style.left=((p.facts.lon+8)*10)+'%';b.style.top=((59.1-p.facts.lat)*59/550*100)+'%';const offset=offsets[p.handle];if(offset){b.style.marginLeft=offset[0]+'px';b.style.marginTop=offset[1]+'px';const leader=document.createElement('i');leader.className='cp-pin-leader';leader.style.width=Math.hypot(...offset)+'px';leader.style.transform='rotate('+Math.atan2(-offset[1],-offset[0])+'rad)';b.append(leader);}b.setAttribute('aria-label',p.title);b.setAttribute('aria-pressed','false');b.title=p.title;const n=document.createElement('span');n.textContent=String(i+1).padStart(2,'0');b.append(n);b.addEventListener('click',()=>pinClick(b,p.handle));$('[data-map-pins]').append(b);});$('[data-map-pins]').append(chooser);
 all('[data-mode-button]').forEach(b=>b.addEventListener('click',()=>show(b.dataset.modeButton)));
 all('[data-hill-select]').forEach(s=>s.addEventListener('change',()=>choose(s.value)));
 $('[data-see-room]').addEventListener('click',()=>{show('room');$('[data-panel="room"] [data-hill-select]').focus({preventScroll:true});$('[data-panel="room"]').scrollIntoView({block:'start',behavior:'auto'});});
 $('[data-room-size]').addEventListener('change',room);
 $('[data-room-scene]').addEventListener('change',e=>$('[data-room-stage]').dataset.scene=e.target.value);
 all('[data-wall]').forEach(b=>b.addEventListener('click',()=>{$('[data-room-stage]').style.setProperty('--wall',b.dataset.wall);all('[data-wall]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));}));
 const gift=$('[data-gift-form]');[...gift.elements.budget.options].forEach(o=>o.textContent='Up to '+money.format(Number(o.value)/100));gift.addEventListener('submit',e=>{e.preventDefault();const country=gift.elements.country.value,occasion=gift.elements.occasion.value,budget=Number(gift.elements.budget.value);let matches=products.filter(p=>(country==='any'||p.facts.country===country)&&p.variants.some(v=>v.available&&v.price<=budget));if(occasion==='summit')matches.sort((a,b)=>b.facts.height-a.facts.height);const fav=['ben-nevis','scafell-pike','yr-wyddfa','helvellyn','catbells','ben-lomond','pen-y-fan','buachaille-etive-mor','tryfan','blencathra','schiehallion','great-gable','skiddaw','cairn-gorm','ingleborough','pen-y-ghent','whernside','snaefell','kinder-scout','an-teallach'];const rank=p=>{const i=fav.indexOf(p.handle);return i<0?99:i};if(occasion!=='summit')matches.sort((a,b)=>rank(a)-rank(b)||a.title.localeCompare(b.title));const cards=matches.slice(0,3).map(p=>{const variants=p.variants.filter(v=>v.available&&v.price<=budget).sort((a,b)=>b.price-a.price||(a.colour==='Midnight')-(b.colour==='Midnight'));const v=variants[0];const a=document.createElement('a');a.href=p.url+'?variant='+v.id;const image=document.createElement('img');image.src=art(p);image.alt=p.title;image.loading='lazy';image.width=297;image.height=420;const title=document.createElement('h4');title.textContent=p.title;const price=document.createElement('p');price.textContent=String(v.title).split(' / ')[0].replace(/(\d)x(\d)/,'$1 × $2')+' · '+money.format(v.price/100);a.append(image,title,price);return a;});$('[data-gift-cards]').replaceChildren(...cards);text('[data-gift-reason]',cards.length?root.dataset['reason'+occasion[0].toUpperCase()+occasion.slice(1)]:root.dataset.empty);$('[data-gift-results]').hidden=false;$('[data-gift-results]').focus({preventScroll:true});$('[data-gift-results]').scrollIntoView({block:'nearest',behavior:'auto'});});
 all('[data-experience-controls]').forEach(e=>e.hidden=false);choose(selected.handle);show(root.dataset.mode||'map');
}
const start=()=>document.querySelectorAll('[data-experience]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-hill-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-hill-card]')];
    const grid = root.querySelector('[data-finder-grid]');
    const search = root.querySelector('[data-hill-search]');
    const country = root.querySelector('[data-hill-country]');
    const sort = root.querySelector('[data-hill-sort]');
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-finder-empty]');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[-’']/g,' ');
    const filter = () => {
      const terms = normalize(search?.value.trim() || '').split(/\s+/).filter(Boolean);
      let total = 0;
      cards.forEach(card => { const matches = terms.every(term => normalize(card.dataset.search).includes(term)) && (!country?.value || country.value === card.dataset.country); card.hidden = !matches; if (matches) total++; });
      count.textContent = `${total} ${total === 1 ? count.dataset.single : count.dataset.plural}`;
      empty.hidden = total > 0;
    };
    root.querySelector('[data-finder-tools]')?.removeAttribute('hidden');
    root.querySelector('[data-view-switch]')?.removeAttribute('hidden');
    search?.addEventListener('input', filter); country?.addEventListener('change', filter);
    sort?.addEventListener('change', () => {
      const ordered = [...cards].sort((a,b) => sort.value === 'name' ? a.dataset.name.localeCompare(b.dataset.name) : sort.value === 'height' ? Number(b.dataset.height)-Number(a.dataset.height) : sort.value === 'price' ? Number(a.dataset.price)-Number(b.dataset.price) : Number(a.dataset.order)-Number(b.dataset.order));
      ordered.forEach(card => grid.append(card));
    });
    root.querySelector('[data-clear-filters]')?.addEventListener('click', () => { if(search) search.value=''; if(country) country.value=''; filter(); search?.focus(); });
    root.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => { root.dataset.mode=button.dataset.view; root.querySelectorAll('[data-view]').forEach(other=>other.setAttribute('aria-pressed',String(other===button))); }));
    if (search) filter();
  }
  const start = () => document.querySelectorAll('[data-hill-finder]').forEach(init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-print-set"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root){
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    let products;
    try{products=JSON.parse(root.querySelector('[data-set-products]').textContent);}catch{return;}
    const selectors=[...root.querySelectorAll('[data-set-hill]')];
    const size=root.querySelector('[data-set-size]'),colour=root.querySelector('[data-set-colour]');const tone=()=>colour?colour.value:'Ivory';
    const add=root.querySelector('[data-set-add]');
    const error=root.querySelector('[data-set-error]');
    const presets={peaks:['ben-nevis','scafell-pike','yr-wyddfa'],lakes:['catbells','helvellyn','scafell-pike']};
    const presetButtons=[...root.querySelectorAll('[data-set-preset]')];
    const choosePreset=key=>{const handles=presets[key];if(!handles||!handles.every(h=>products.some(p=>p.handle===h)))return false;selectors.forEach((s,i)=>s.value=handles[i]);return true;};
    let items=[],busy=false;
    const money=new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
    const update=()=>{
      items=[];let total=0,valid=true;
      let selectedName=root.dataset.customLabel;
      presetButtons.forEach(button=>{const handles=presets[button.dataset.setPreset];const selected=handles.every(h=>selectors.some(s=>s.value===h));button.setAttribute('aria-pressed',String(selected));if(selected)selectedName=button.querySelector('strong').textContent;});
      root.querySelector('[data-set-selection]').textContent=selectedName;
      selectors.forEach((select,index)=>{
        const product=products.find(p=>p.handle===select.value);
        const variant=product?.variants.find(v=>v.name.split(' ')[0]===size.value && (!v.colour||v.colour===tone()) && v.available);
        if(!variant)valid=false;else{items.push({id:variant.id,quantity:1});total+=variant.price;}
        if(product){const wallArt=root.querySelectorAll('[data-range-art]')[index];if(wallArt)wallArt.src=tone()==='Midnight'&&product.artMidnight?product.artMidnight:product.art;const slot=select.closest('.cp-set-slot');const image=slot.querySelector('img');image.removeAttribute('srcset');image.src=product.image;image.alt=product.title;slot.querySelector('a').href=product.url;}
        [...select.options].forEach(option=>option.disabled=selectors.some(other=>other!==select && other.value===option.value));
      });
      root.querySelector('[data-range-room]').dataset.size=size.value;
      const different=new Set(selectors.map(s=>s.value)).size===3;
      add.disabled=!valid||!different||busy;
      add.textContent=`${root.dataset.addLabel} — ${money.format(total/100)}`;
      error.textContent=valid&&different?'':root.dataset.unavailable;
    };
    selectors.forEach(select=>{select.disabled=false;select.addEventListener('change',update);});
    size.addEventListener('change',update);if(colour)colour.addEventListener('change',update);
    presetButtons.forEach(button=>{button.disabled=!presets[button.dataset.setPreset].every(h=>products.some(p=>p.handle===h));button.addEventListener('click',()=>{if(!busy&&choosePreset(button.dataset.setPreset))update();});});
    root.querySelector('[data-set-presets]').hidden=false;
    const params=new URLSearchParams(window.location.search);
    choosePreset(params.get('set'));
    const initialHill=params.get('hill');
    if(products.some(p=>p.handle===initialHill)&&!selectors.some(s=>s.value===initialHill))selectors[0].value=initialHill;
    if(['30x40','50x70','70x100'].includes(params.get('size')))size.value=params.get('size');if(colour&&['Ivory','Midnight'].includes(params.get('colour')))colour.value=params.get('colour');
    root.querySelectorAll('[data-range-colour]').forEach(button=>button.addEventListener('click',()=>{root.querySelector('[data-range-room]').style.setProperty('--room-wall',button.dataset.rangeColour);root.querySelectorAll('[data-range-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));
    root.querySelector('[data-set-purchase]').hidden=false;
    add.addEventListener('click',async()=>{
      if(busy||add.disabled)return;
      update();if(add.disabled)return;
      busy=true;selectors.forEach(s=>s.disabled=true);size.disabled=true;if(colour)colour.disabled=true;presetButtons.forEach(b=>b.disabled=true);add.disabled=true;add.textContent=root.dataset.addingLabel;error.textContent='';
      try{
        const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...items].reverse()})});
        const result=await response.json();
        if(!response.ok){busy=false;selectors.forEach(s=>s.disabled=false);size.disabled=false;if(colour)colour.disabled=false;presetButtons.forEach(b=>b.disabled=!presets[b.dataset.setPreset].every(h=>products.some(p=>p.handle===h)));update();error.textContent=result.description||root.dataset.errorLabel;return;}
        window.location.assign(root.dataset.cartUrl);
      }catch{
        error.textContent=root.dataset.errorLabel;
        const link=document.createElement('a');link.href=root.dataset.cartUrl;link.textContent=root.dataset.cartLabel;error.append(' ',link);
      }
    });
    update();
  }
  const start=()=>document.querySelectorAll('[data-print-set]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-reviews"] && !Shopify.designMode) return;
  try {
    
(()=>{const start=()=>document.querySelectorAll('.cp-review-form').forEach(d=>{if(d.querySelector('[role="status"],.errors'))d.open=true;});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();document.addEventListener('shopify:section:load',start);})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
